<script setup lang="ts">
import BadgeItem from '@/common/components/molecules/badge/BadgeItem.vue';
import { type Props, setup } from './myInfoPopupProfileArea.setup';

const props = defineProps<Props>();
const { userRoleName } = setup(props);
</script>

<template>
  <div class="my-info-profile">
    <div
      class="my-info-profile__image"
      :class="props.userProfile.profileImage"
    />
    <div class="my-info-profile__meta">
      <p class="profile-name-wrapper">
        <span class="profile-name">
          {{ props.userProfile.name }}
        </span>
        <badge-item
          v-if="!!userRoleName"
          class="profile-role"
          size="xsmall"
          html-type="span"
        >
          {{ userRoleName }}
        </badge-item>
      </p>
      <p class="profile-email">{{ props.userProfile.email }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.my-info-profile {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  &__image {
    position: absolute;
    top: 18px;
    left: 18px;
    width: 60px;
    height: 60px;
    border: 2px solid var(--color-blue-00-03);
    border-radius: 30px;
  }

  &__meta {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    padding: 16px 20px 4px;
    border: 1px solid var(--color-gray-05-03);
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    background-color: var(--color-gray-06-00);
    color: var(--main-font-color);

    .profile-name-wrapper {
      display: flex;
      gap: 6px;
      align-items: center;
    }
    .profile-role {
      height: 20px;
      padding: 4px 6px;
      background-color: var(--main-font-color);
      font-size: 10px;
      font-weight: 500;
      color: var(--color-gray-12-00);
    }
    .profile-name {
      font-size: 18px;
      font-weight: 700;
      line-height: 140%;
    }
    .profile-email {
      font-size: 12px;
      line-height: 130%;
      color: var(--color-gray-03-09);

      @include shortening(block);
    }
  }
}
</style>
